import { default as indexbVK8ERtDnaMeta } from "/home/circleci/project/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/circleci/project/pages/index.vue").then(m => m.default || m)
  }
]